import * as fns from 'date-fns'
import { ServiceClient } from 'src/utils'
import {
    SerasaAuditCall,
    SerasaAuditStatistics,
    SerasaAvailableEndpoints,
    SerasaAvailableStatus
} from './serasa-history.types'

const serviceClient = ServiceClient.singleton()

export class SerasaHistoryService {
    static #INSTANCE = new SerasaHistoryService()
    static readonly singleton = () => SerasaHistoryService.#INSTANCE

    async fetchSerasaAvailableStatus() {
        return serviceClient.authGet<SerasaAvailableStatus[]>('/api/serasahistory/available-status/v1')
    }

    async fetchSerasaAvailableEndpoints() {
        return serviceClient.authGet<SerasaAvailableEndpoints[]>('/api/serasahistory/available-endpoints/v1')
    }

    async fetchSerasaHistoryStatistics(
        startDate: Date,
        endDate: Date,
        status: string,
        endpoint: string,
        groupField?: string
    ) {
        const queryParams = new URLSearchParams()

        startDate && queryParams.append('startDate', fns.formatDate(startDate, 'yyyy-MM-dd'))
        endDate && queryParams.append('endDate', fns.formatDate(endDate, 'yyyy-MM-dd'))
        status && queryParams.append('status', status)
        endpoint && queryParams.append('endpoint', endpoint)
        groupField && queryParams.append('groupBy', groupField)

        const url = '/api/serasahistory/history-statistics/v1?' + queryParams.toString()

        return serviceClient.authGet<SerasaAuditStatistics[]>(url)
    }

    async fetchSerasaHistoryData(startDate: Date, endDate: Date, status: string, endpoint: string) {
        const queryParams = new URLSearchParams()

        startDate && queryParams.append('startDate', fns.formatDate(startDate, 'yyyy-MM-dd'))
        endDate && queryParams.append('endDate', fns.formatDate(endDate, 'yyyy-MM-dd'))
        status && queryParams.append('status', status)
        endpoint && queryParams.append('endpoint', endpoint)

        const url = '/api/serasahistory/history-report/v1?' + queryParams.toString()

        return serviceClient.authGet<SerasaAuditCall[]>(url)
    }
}

export default SerasaHistoryService.singleton()
